module.exports = __webpack_public_path__ + "static/media/Item 17.984bf7ce.jpg";